import React, { useState, useEffect } from "react";
import moment from "moment";
import Loader from "components/Loader";
import AuditLogTile from "./AuditLogTile";
import { AuditLogValues } from "state/request_details_dependencies";


interface RequestAuditLogProps {
  auditLogs?: AuditLogValues[];
  isLoading?: boolean;
}

const RequestAuditLogs: React.FC<RequestAuditLogProps> = ({ auditLogs, isLoading }) => {
    const [hasShownLoader, setHasShownLoader] = useState(false);
    const [minLoadingTime, setMinLoadingTime] = useState(true);

    useEffect(() => {
        // Ensure loader shows for at least 1 second
        const timer = setTimeout(() => {
            setMinLoadingTime(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        // Track if we've ever had data
        if (auditLogs && auditLogs.length > 0) {
            setHasShownLoader(true);
        }
    }, [auditLogs]);

  const shouldShowLoader =
    isLoading || auditLogs === undefined || (minLoadingTime && !hasShownLoader);

    return (
        <div style={{
            marginTop: '24px',
            padding: '20px',
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
        }}>
            <h3 style={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#111827',
                marginBottom: '16px',
            }}>
                Activity Logs
            </h3>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: !shouldShowLoader && auditLogs && auditLogs.length > 5 ? "400px" : "none",
          overflowY: !shouldShowLoader && auditLogs && auditLogs.length > 5 ? "auto" : "visible",
          paddingRight: !shouldShowLoader && auditLogs && auditLogs.length > 5 ? "8px" : "0",
        }}
      >
        {shouldShowLoader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "40px",
            }}
          >
            <Loader />
          </div>
        ) : auditLogs && auditLogs.length > 0 ? (
          auditLogs.map((log, index) => <AuditLogTile log={log} index={index} />)
        ) : (
          <div
            style={{
              padding: "12px",
              backgroundColor: "#ffffff",
              borderRadius: "6px",
              textAlign: "center",
              color: "#9ca3af",
              fontSize: "12px",
            }}
          >
            No activity logs available
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestAuditLogs;